import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/guides/umre-hac-rehberi-hero.webp")